import { z } from "zod";

export const UserPostReactionSchema = z.object({
    userReaction: z
        .object({
            id: z.number(),
            reaction: z.enum(["LIKE", "UNLIKE"]),
        })
        .nullable(),
    postLikeCount: z.number(),
    postDislikeCount: z.number(),
});
